import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { addLocale } from 'primereact/api';

addLocale('tr', {
  firstDayOfWeek: 1,
  closeText: 'kapat',
  prevText: 'geri',
  nextText: 'ileri',
  currentText: 'bugün',
  monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
  monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
  dayNamesShort: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
  dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
  weekHeader: 'Hf',
  firstDay: 1,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: '',
  timeOnlyTitle: 'Zaman Seçiniz',
  timeText: 'Zaman',
  hourText: 'Saat',
  minuteText: 'Dakika',
  secondText: 'Saniye',
  ampm: false,
  month: 'Ay',
  week: 'Hafta',
  day: 'Gün',
  emptyMessage: 'Seçilecek bir öğe yok',
});

function CalendarComponent(props) {
 
  const [date, setDate] = useState(null);
  const locale = props.lang === 'tr-TR' ? 'tr' : undefined;

  return (
    <Calendar
      value={props.date}
      className={`customDatePicker dateBox w-100 ${props.className === undefined ? 'mb-2 mb-sm-0 me-0 me-sm-2' : props.className}` }
      panelClassName={` customDatePickerPanel`}
      onChange={(e) => {
        setDate(e.value);
        props.change(e.value);
      }}
      dateFormat="dd.mm.yy"
      showIcon
      locale={locale}
    />
  );
}

export default CalendarComponent;
